class ValidationResult {
    _messages = [];
    addValidation(message) {
        this._messages.push(message);
    }
    get messages() {
        return this._messages;
    }
}

export { ValidationResult };
//# sourceMappingURL=validation-result.mjs.map
